import PropTypes from "prop-types";
import styles from "./styles.module.css";
import { priceFormatter } from "@/src/helpers/number-formatter";

const PriceDetail = ({ price, currency }) => {
  if (!price) return null;

  const { priceVisibility, min, max, startPrice } = price;

  if (priceVisibility === "ASK") return null;

  const isRange = priceVisibility === "RANGE";
  const isStartCount = priceVisibility === "STARTCOUNT";

  const displayPrice = isStartCount ? startPrice : min;
  if (!displayPrice) return null;

  return (
    <div className={styles.wrapper}>
      <p className={styles.range}>
        {priceFormatter(displayPrice)}&nbsp;{currency.symbol}
        {isRange && max && (
          <>
            &nbsp;-&nbsp;{priceFormatter(max)}&nbsp;{currency.symbol}
          </>
        )}
        {isStartCount && <span className={styles.description}>&apos;den Başlayan Fiyatlar</span>}
      </p>
      {isRange && <p className={styles.description}>fiyat aralığında gayrimenkuller</p>}
    </div>
  );
};

PriceDetail.propTypes = {
  price: PropTypes.object,
  currency: PropTypes.object,
};

export default PriceDetail;
